import React from 'react'
import { Modal } from 'react-bootstrap'
import { actions as formActions } from 'react-redux-form'
import groupBy from 'lodash/groupBy'

import Form from '../../form/Form'
import Field from '../../form/Field'
import { clearEventErrors, saveNewEvent } from '../../../actions/profileViewActions'
import { loadSurveys } from '../../../actions/surveys'
import * as v from '../../form/validations.js'

const EditForm = ({
  cancelAction,
  saveAction,
  setStep,
  surveys,
  setAllDay,
  allDayEvent,
  currentStep,
  eventEditError
}) => {
  const formModel = 'profileForms.calendarEventForm'
  const model = path => `${formModel}.${path}`
  const lastStep = 2

  console.log('ERR', eventEditError)

  return (
    <Form
      model={formModel}
      onSubmit={f => saveAction(f)}
      onUpdate={form => {
        setAllDay(form.allDay.value)
      }}>
      {form => (
        <div>
          {eventEditError && (
            <div className="alert alert-danger">
              An error occurred while adding this section
            </div>
          )}
          <Field
            model={model(`eventName`)}
            form={form}
            required={true}
            label="Event Name"
            type="text"
          />

          <Field
            model={model(`aboutTitle`)}
            form={form}
            label="Event About title (blank for default)"
            type="text"
          />

          <Field
            model={model(`descriptionTitle`)}
            form={form}
            label="Event Description title (blank for default)"
            type="text"
          />

          <Field
            model={model(`eventDescription`)}
            form={form}
            label="Event Description"
            type="textarea"
          />

          <Field model={model(`location`)} form={form} label="Location" type="text" />

          <div className="row">
            <div className="col-xs-5">
              <Field
                model={model(`eventDate`)}
                form={form}
                required={true}
                validate={[v.isDate({})]}
                label="Start Date"
                type="datetime"
                timeFormat={!allDayEvent}
              />
            </div>
            <div className="col-xs-5">
              <Field
                model={model(`endDate`)}
                form={form}
                label="End Date"
                type="datetime"
                timeFormat={!allDayEvent}
              />
            </div>
            <div className="col-xs-2">
              <Field
                model={model(`allDay`)}
                form={form}
                label="All Day"
                type="checkbox"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <Field
                model={model(`canRsvp`)}
                form={form}
                label="Can RSVP"
                type="checkbox"
              />
            </div>
            <div className="col-sm-3">
              <Field
                model={model(`isApplication`)}
                form={form}
                label="Is Application"
                type="checkbox"
              />
            </div>
            <div className="col-sm-3">
              <Field
                model={model(`currentlyAcceptingRsvp`)}
                form={form}
                label="Currently Accepting RSVP"
                type="checkbox"
              />
            </div>
            <div className="col-sm-3">
              <Field model={model(`maxRsvp`)} form={form} label="Max RSVPs" type="text" />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-8">
              <Field
                model={model(`rsvpTitle`)}
                form={form}
                label="Application/RSVP title (blank for default)"
                type="text"
              />
            </div>
            <div className="col-xs-4">
              <Field
                model={model(`rsvpButtonText`)}
                form={form}
                label="Application/RSVP button text (blank for default)"
                type="text"
              />
            </div>
          </div>

          <Field
            model={model(`messagePostResponse`)}
            form={form}
            label="Message to user after responding"
            type="textarea"
          />

          <div className="row">
            <div className="col-xs-6">
              <Field
                model={model(`onScreenAcceptanceText`)}
                form={form}
                label="Text on screen when accepted"
                type="textarea"
              />
            </div>
            <div className="col-xs-6">
              <Field
                model={model(`emailAcceptanceText`)}
                form={form}
                label="Text in message when accepted"
                type="textarea"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <Field
                model={model(`onScreenRejectionText`)}
                form={form}
                label="Text on screen when rejected"
                type="textarea"
              />
            </div>
            <div className="col-xs-6">
              <Field
                model={model(`emailRejectionText`)}
                form={form}
                label="Text in message when rejected"
                type="textarea"
              />
            </div>
          </div>

          <Field
            model={model('survey')}
            form={form}
            options={surveys}
            createFromValue={value => ({ label: value.name, value })}
            label="Survey"
            type="SimpleSelect"
          />

          <input type="submit" className="submit" value="Submit" />
          <button type="button" onClick={cancelAction} className="cancel">
            Cancel
          </button>
        </div>
      )}
    </Form>
  )
}

class ProfileSectionCalendar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      allDayEvent: false,
      currentStep: 0
    }
  }

  setAllDay(myThis) {
    return v => {
      myThis.setState({
        ...myThis.state,
        allDayEvent: v
      })
    }
  }

  closeModal(myThis) {
    myThis.setState({ modalOpen: false })
  }

  openModal() {
    this.setState({
      currentStep: 0,
      modalOpen: true
    })
  }

  addIf() {
    const profile = this.props.profile
    const myThis = this

    if (profile.permissions.canEdit || profile.permissions.canAdminister) {
      return (
        <div>
          <button
            className="btn btn-gray btn-small"
            onClick={() =>
              myThis.props
                .dispatch(loadSurveys(profile.type, profile.id, false))
                .then(() => {
                  myThis.props.dispatch(clearEventErrors())
                  myThis.props.dispatch(
                    formActions.reset('profileForms.calendarEventForm')
                  )

                  myThis.setState({
                    currentStep: 0,
                    modalOpen: true
                  })
                })}>
            Add Event
          </button>
        </div>
      )
    }

    return null
  }

  generate() {
    const section = this.props.section
    const displayEvents = section.futureEvents
    const gDate = section.groupByDate

    if (displayEvents) {
      if (gDate) {
        const groupedEvents = groupBy(displayEvents, d => {
          const d2 = new Date(d.eventStartDate)

          return `${d2.getMonth() + 1}/${d2.getDate()}/${1900 + d2.getYear()}`
        })

        return (
          <div>
            <ul className="schedule">
              {Object.keys(groupedEvents).map(g => (
                <li className="daygroup" key={g}>
                  <span className="eventdate">{g}</span>
                  <ul className="allevents">
                    {groupedEvents[g].map(ge => (
                      <li className="events">
                        <div className="eventname">
                          <a href={ge.eventUrl}>{ge.eventName}</a>
                        </div>
                        <div className="description">{ge.description}</div>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
            {this.addIf()}
          </div>
        )
      }

      return (
        <div>
          <ul className="schedule">
            <li className="daygroup">
              <ul className="allevents">
                {displayEvents.map(ge => (
                  <li className="events" key={ge.eventUrl}>
                    <div className="eventname">
                      <a href={ge.eventUrl}>{ge.eventName}</a>
                    </div>
                    <div className="description">{ge.description}</div>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
          {this.addIf()}
        </div>
      )
    }

    return null
  }

  render() {
    const myThis = this

    console.log('surveys', myThis.props.surveys)

    return (
      <div>
        {this.generate()}
        <Modal
          bsSize="large"
          backdrop="static"
          show={this.state.modalOpen}
          onHide={() => myThis.closeModal(myThis)}>
          <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={() => myThis.closeModal(myThis)}>
              <span aria-hidden="true">×</span>
            </button>
            <Modal.Title>
              <h2>Add Event</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: '15px' }}>
              <EditForm
                currentStep={this.state.currentStep}
                eventEditError={this.props.eventEditError}
                setStep={s => myThis.setState({ ...this.state, currentStep: s })}
                setAllDay={myThis.setAllDay(myThis)}
                allDayEvent={this.state.allDayEvent}
                surveys={
                  myThis.props.surveys
                    ? myThis.props.surveys.data.map(s => ({
                        label: s.name,
                        value: s
                      }))
                    : []
                }
                saveAction={f => {
                  console.log(f)
                  myThis.props
                    .dispatch(
                      saveNewEvent(
                        myThis.props.profile.type,
                        myThis.props.profile.id,
                        myThis.props.section.id,
                        f
                      )
                    )
                    .then(() => myThis.closeModal(myThis))
                }}
                cancelAction={() => myThis.closeModal(myThis)}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default ProfileSectionCalendar
